import { UserGroupApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function useUpdate() {
  const queryClient = useQueryClient();

  return useAuthMutation(UserGroupApi.patch, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
    },
  });
}

export default useUpdate;
